/**
 * Этапы обучения. Единый источник правды для оглавления в сайдбаре
 * и для секций на странице. Скриншоты подставляются позже — кладутся в
 * public/getting-started/<screenshot>, Webpack CopyPlugin копирует public/ в dist/.
 * Пока файла нет — рисуется плейсхолдер.
 */
export interface GettingStartedStep {
  /** id секции (используется как DOM id и ключ подсветки) */
  id: string;
  /** короткий заголовок для оглавления в сайдбаре */
  navLabel: string;
  /** заголовок секции на странице */
  title: string;
  /** абзацы описания */
  paragraphs: string[];
  /** имя файла скриншота в /getting-started/ (без пути). null = плейсхолдер. */
  screenshot: string | null;
  /** опциональная кнопка-действие, ведёт внутри кабинета */
  action?: { label: string; to: string };
}

export const GETTING_STARTED_STEPS: GettingStartedStep[] = [
  {
    id: 'create-assistant',
    navLabel: 'Создать ассистента',
    title: 'Шаг 1. Создать ассистента',
    paragraphs: [
      'Ассистент — это ваш ИИ-помощник, который отвечает клиентам по вашим материалам. Нажмите «Создать ассистента», задайте имя и промпт — короткую инструкцию о том, как ассистент должен себя вести и о чём отвечать.',
      'Имя видно только вам в кабинете. Промпт задаёт характер ответов: например, «Ты — вежливый консультант магазина электроники, отвечай кратко и по делу».',
    ],
    screenshot: 'step-1-create.png',
    action: { label: 'Перейти к ассистентам', to: '/assistants' },
  },
  {
    id: 'upload-knowledge',
    navLabel: 'Загрузить базу знаний',
    title: 'Шаг 2. Загрузить базу знаний',
    paragraphs: [
      'База знаний — это то, на чём ассистент строит ответы. Загрузите документы (PDF, DOCX, PPTX, XLSX, TXT) или добавьте ссылки на страницы сайта — ассистент прочитает их и будет отвечать на их основе.',
      'Обработка документов платная (0,5 ₽ за страницу, 1 ₽ за картинку), но загрузка не блокируется при нехватке средств — стоимость спишется при следующем пополнении. Так вы можете пройти весь путь настройки бесплатно.',
    ],
    screenshot: 'step-2-knowledge.png',
  },
  {
    id: 'test-chat',
    navLabel: 'Протестировать',
    title: 'Шаг 3. Протестировать в тест-чате',
    paragraphs: [
      'Перед тем как показывать ассистента клиентам, проверьте его в тест-чате прямо в кабинете. Задайте вопросы, посмотрите, как он отвечает, при необходимости поправьте промпт или добавьте материалы в базу знаний.',
      'Тест-чат бесплатный — общайтесь с ассистентом сколько угодно, это не списывает баланс.',
    ],
    screenshot: 'step-3-test.png',
  },
  {
    id: 'connect-channel',
    navLabel: 'Подключить канал',
    title: 'Шаг 4. Подключить канал',
    paragraphs: [
      'Когда ассистент отвечает как нужно — раздайте его клиентам. Доступно три канала: Telegram-бот, мессенджер MAX и виджет на ваш сайт.',
      'Для Telegram и MAX понадобится токен бота, для виджета — вставить короткий скрипт на сайт (кабинет сам сгенерирует код и покажет, куда его вставить).',
    ],
    screenshot: 'step-4-channels.png',
  },
  {
    id: 'topup-balance',
    navLabel: 'Пополнить баланс',
    title: 'Шаг 5. Пополнить баланс',
    paragraphs: [
      'В боевых каналах каждая пара «вопрос клиента + ответ ассистента» стоит 10 ₽. Чтобы ассистент работал с реальными клиентами, пополните баланс на странице «Биллинг».',
      'Минимальная сумма пополнения — 1000 ₽. Там же видна вся история списаний и сводка расходов по каналам и дням.',
    ],
    screenshot: 'step-5-balance.png',
    action: { label: 'Перейти к биллингу', to: '/billing' },
  },
];
